export default "__VITE_ASSET__2959450e__"